/**
 * @description : fetch, parse and validate tracking codes
 * @requires {Object} applicationModel
 * @requires {Object} configService
 * @requires {Object} googleRecaptchaService
 * @requires {Object} numberService
 * @requires {Object} parcelForceService
 * @requires {Object} overlayService
 * @requires {Object} parcelsService
 * @requires {Object} tealiumService : provides methods to work with tealium object tags.
 * @requires {Object} trackingCodeService
 * @requires {Object} trackingService
 * @requires {Object} $location
 * @requires {Object} $cookies
 * @requires {Object} $rootScope
 * @requires {Object} $scope
 * @requires {Function} $timeout
 * @requires {Object} $window
 */
function trackingCodeController(
  applicationModel,
  configService,
  googleRecaptchaService,
  numberService,
  parcelForceService,
  overlayService,
  parcelsService,
  tealiumService,
  trackingCodeService,
  trackingService,
  $location,
  $cookies,
  $rootScope,
  $scope,
  $timeout,
  $window) {

  const vm = this;
  const inputElem = document.getElementById('track-item');
  let sanitizedTrackingNumber;
  let errTags;

  // Set tealiumService.
  const persistentTags = {

    pageApplicationName: configService.tealium.app_name,
    pagePersona: configService.tealium.instance.toLowerCase(),
    pageLanguage: (document.documentElement.lang === 'en') ? 'en-gb' : document.documentElement.lang

  };

  // Pollyfill for remove().
  if (!('remove' in Element.prototype)) {

    Element.prototype.remove = () => {

      if (this.parentNode) {

        this.parentNode.removeChild(this);

      }

    };

  }

  tealiumService.setBaseTags(persistentTags);

  if (document.getElementById('flmnt-placeholder')) {

    const childPlaceholder = document.getElementById('flmnt-placeholder');
    childPlaceholder.parentNode.removeChild(childPlaceholder);

  }

  if (document.getElementById('flmntChatbot')) {

    const child = document.getElementById('flmntChatbot');
    child.parentNode.removeChild(child);

  }

  if (document.getElementById('flmntWidgetInit')) {

    const childWidget = document.getElementById('flmntWidgetInit');
    childWidget.parentNode.removeChild(childWidget);

  }

  /**
   * @description : generates tealium tags for this page.
   * @param {Boolean} isLoggedIn
   * @param {Object} error
   * @returns {Object}
   */
  function searchPage(isLoggedIn, error) {

    const errorObj = angular.isObject(error) ? error : {};
    const cookie = $cookies.get('parcels_jwt');
    const JWT = parcelsService.decodeJWT(cookie);
    const errorType = (parcelsService.isSet(errorObj, 'status')) ? 'System Error' : 'Field Validation';
    const breadCrumb = (parcelsService.isSet(configService, 'breadcrumbs')) ?
    JSON.parse(configService.breadcrumbs) : '';

    const tags = {
      pageName: `${configService.tealium.site_prefix} >${configService.tealium.instance} >Track Your Items >Search`,
      pageMenuTree: `${configService.tealium.instance}|Track Your Items|Search`,
      pageApplicationStep: 'Search',
      pageTemplate: 'Search Form',
      pageBreadCrumb: (Array.isArray(breadCrumb) && breadCrumb.length > 1) ?
        breadCrumb.join('|') : breadCrumb.toString()
    };

    const userTags = {
      visitorGUID: parcelsService.isSet(JWT, 'sub'),
      visitorEmail: parcelsService.isSet(JWT, 'email'),
      visitorSegment: parcelsService.isSet(JWT, 'visitorSegment'),
      visitorRMPPost: parcelsService.isSet(JWT, 'visitorRMPPost'),
      visitorRMPPhone: parcelsService.isSet(JWT, 'visitorRMPPhone'),
      visitorRMPEmail: parcelsService.isSet(JWT, 'visitorRMPEmail'),
      visitorRMPOther: parcelsService.isSet(JWT, 'visitorRMPOther')
    };

    const errorTags = {
      pageName:
      `${configService.tealium.site_prefix} >${configService.tealium.instance} >Track Your Items >Search Error`,
      pageMenuTree: `${configService.tealium.instance}|Track Your Items|Search Error`,
      pageErrorType: errorType,
      pageErrorMessage: `${errorType}:${(parcelsService.isSet(errorObj, 'status')) ? errorObj.status : 0}:\
${(Object.keys(errorObj).length > 0 && error) ? parcelsService.isSet(errorObj[0], 'errorCode') : 0}`,
      pageApplicationStep: 'Search Error',
      pageTemplate: 'Search Form',
      pageBreadCrumb: (Array.isArray(breadCrumb) && breadCrumb.length > 1) ?
        breadCrumb.join('|') : breadCrumb.toString()
    };

    if (isLoggedIn) {

      if (Object.keys(errorObj).length === 0 && error === undefined) return angular.merge(tags, userTags);
      if (Object.keys(errorObj).length > 0 || error !== undefined) return angular.merge(errorTags, userTags);

    }

    if (!isLoggedIn) {

      if (Object.keys(errorObj).length > 0 || error !== undefined) return errorTags;

    }

    return tags;

  }

  function resetErrors() {

    vm.showError = false;
    vm.errorMessages = [];
    applicationModel.urlRequest = {};

  }

  function displayErrors(errorMessages) {

    let errorCode;
    resetErrors();

    if (Array.isArray(errorMessages)) {

      vm.errorMessages = errorMessages;
      errorCode = parcelsService.isSet(vm.errorMessages[0], 'errorCode');

    } else if (typeof errorMessages === 'string' || errorMessages instanceof String) {

      vm.errorMessages.push(errorMessages);

    } else if (angular.isDefined(errorMessages.data)) {

      if (angular.isDefined(errorMessages.data.errors)) {

        vm.errorMessages.push(errorMessages.data.errors[0]);
        errorCode = parcelsService.isSet(errorMessages.data.errors[0], 'errorCode');

      }

    } else if (angular.isDefined(errorMessages.errors)) {

      vm.errorMessages.push(errorMessages.errors);
      errorCode = parcelsService.isSet(errorMessages.errors[0], 'errorCode');

    } else if (angular.isDefined(errorMessages.error)) {

      vm.errorMessages.push(errorMessages.error[0]);
      errorCode = parcelsService.isSet(errorMessages.error[0], 'errorCode');

    } else {

      vm.errorMessages.push(errorMessages.errorDescription);

    }

    // Not displaying 401 Unauthorised response errors.
    vm.showError = (errorCode !== 'E0015');

    // Set tealium error object.
    errTags = searchPage(vm.isLoggedIn, errorMessages);
    tealiumService.sendTags(errTags);

  }

  function displayResults(response) {

    // TODO Remove deprecated Header once APIm 3.2 is deployed.
    if (response.headers('x-recaptcha-session')) {

      applicationModel.googleRecaptcha.sessionToken = response.headers('x-recaptcha-session');

    }

    // Set the session token for any response. Also error responses.
    if (response.headers('X-RMG-API-Session')) {

      applicationModel.googleRecaptcha.sessionToken = response.headers('X-RMG-API-Session');

    }

    if (parcelsService.checkNested(response, 'data', 'errors')) {

      displayErrors(response.data.errors);

    } else {

      applicationModel.trackingDetails = response.data;
      applicationModel.estimatedDelivery = response.data.mailPieces.estimatedDelivery;
      $location.path(`/tracking-results/${response.data.mailPieces.mailPieceId}`);

    }

  }

  function processRequest(trackingNumber) {

    trackingService.getEvents(trackingNumber).then(
      displayResults,
      displayErrors
    );

  }

  /**
   * @description : Handle tracking number from the URL address on page load.
   * If there are errors set on the application model display those.
   */
  function checkURLRequest() {

    if (applicationModel.urlRequest.number) {

      vm.trackId = numberService.filterNumber(applicationModel.urlRequest.number);

    }

    if (applicationModel.urlRequest.error) {

      displayErrors(applicationModel.urlRequest.error);

    }

  }

  /**
   * @description : Toggles PFW overlay with/out the tracking number.
   * @param {String} trackingNumber
   */
  function togglePfwOverlay(trackingNumber) {

    overlayService.setPfwTrackingNumber(trackingNumber);
    overlayService.togglePfwOverlay();
    vm.pfwOverlayStatus = overlayService.getPfwOverlayState();

  }

  /**
   * @description : Submit the Track Your Delivery form.
   * @param {String} trackingNumber
   */
  function submit(trackingNumber) {

    // Reset error state in the case where user is retrying after validation issue.
    resetErrors();

    sanitizedTrackingNumber = numberService.sanitize(trackingNumber);
    applicationModel.sanitizedNumber = angular.copy(sanitizedTrackingNumber);
    let isValidNumber = numberService.validate(sanitizedTrackingNumber);

    if (isValidNumber === 'checkPFW') {

      isValidNumber = parcelForceService.checkPFW(isValidNumber, sanitizedTrackingNumber);

    }

    if (isValidNumber === true) {

      const triggerGoogleRecaptchaCheck = (configService.google_recaptcha.enabled)
        ? trackingCodeService.triggerGoogleRecaptchaCheck() : false;

      // Set authToken if the parcels_jwt cookie was found and is valid.
      applicationModel.authToken = (parcelsService.isValidCookie()) ? $cookies.get('parcels_jwt') : null;

      // Invoke Google Recaptcha if needed, and process the request later.
      // See processRequestWithGoogleRecaptchaToken below.
      if (triggerGoogleRecaptchaCheck) {

        googleRecaptchaService.invokeCaptcha();

      } else {

        processRequest(sanitizedTrackingNumber);

      }

    } else if (isValidNumber === 'isPFW') {

      togglePfwOverlay(sanitizedTrackingNumber);

    } else {

      displayErrors(numberService.errorMessageMap(isValidNumber));

    }

  }

  $rootScope.$on('overlayClosed', () => {

    vm.pfwOverlayStatus = overlayService.getPfwOverlayState();

  });

  $rootScope.$on('externalReSubmit', (e, id) => {

    vm.trackId = numberService.filterNumber(id);

    $timeout(() => {

      submit(id);

    }, 100);

  });

  const googleRecaptchaTokenListener = $rootScope.$on('googleRecaptchaTokenAvailable',
    (event, googleRecaptchaToken) => {

      applicationModel.googleRecaptcha.googleToken = googleRecaptchaToken;
      processRequest(applicationModel.sanitizedNumber);

    });

  $scope.$on('$destroy', () => {

    googleRecaptchaTokenListener();

  });

  function overlayClick() {

    overlayService.toggleOverlay();

  }

  function clearPlaceHolder() {

    inputElem.setAttribute('placeholder', '');

  }

  function resetPlaceHolder() {

    const attrVal = configService.messages.tracking_code.tracking_placeholder;
    inputElem.setAttribute('placeholder', attrVal);

  }

  /**
   * @description : Sets the caretPos cursor position for the given element.
   * @param {Object} elem: HTML element.
   * @param {Integer} caretPos: Position for the cursor.
   */
  function setCaretPosition(elem, caretPos) {

    let range;

    if (elem !== null) {

      if (elem.createTextRange) {

        range = elem.createTextRange();
        range.move('character', caretPos);
        range.select();

      } else if (elem.selectionStart) {

        elem.focus();
        elem.setSelectionRange(caretPos, caretPos);

      } else {

        elem.focus();

      }

    }

  }

  function setTrackingCodeSearch() {

    const code = vm.trackId;
    // Get the input code original spaces until the initial cursor's position.
    const originalCodeSpaces = code.substring(0, inputElem.selectionEnd).split(' ').length - 1;
    // Get cursor position or end of element.
    let cursorPosition = inputElem.selectionEnd;
    let formattedCodeSpaces = 0;

    if (code) {

      vm.trackId = numberService.filterNumber(code);

    } else {

      vm.trackId = code;

    }

    // Case when entering number and cursor goes to previous after a whitespace.
    if (inputElem.value.length > 4 && inputElem.selectionEnd === inputElem.value.length) {

      cursorPosition += 1;

    }

    // Add the formatted spaces to the cursor position counting until the current position of the cursor.
    formattedCodeSpaces = (vm.trackId.substring(0, cursorPosition).split(' ').length - 1);
    cursorPosition += ((formattedCodeSpaces - originalCodeSpaces) >= 0)
      ? (formattedCodeSpaces - originalCodeSpaces) : 0;

    // Set the cursor position after the filterNumber function.
    // Wrapped in setTimeout to make it work.
    $timeout(() => {

      setCaretPosition(inputElem, cursorPosition);

    }, 0);

  }

  /**
   * @description : Handle click events outside, to close the popup.
   * @param {MouseEvent} e: Mouse click event
   */
  function handleClose(e) {

    if (vm.pfwOverlayStatus) {

      const popup = document.getElementsByClassName('button-holder');
      const isClickInside = (popup.length > 0) ? popup[0].contains(e.target) : false;

      if (!isClickInside) {

        vm.pfwOverlayStatus = false;
        overlayService.togglePfwOverlay();
        $scope.$apply();

      }

      e.stopPropagation();

    }

  }

  /**
   * @description : Handle key events to close the popup.
   * @param {Event} e: Keyup event
   */
  function handleEsc(e) {

    const evt = e || window.event;
    const isEscape = ('key' in evt) ? (evt.key === 'Escape' || evt.key === 'Esc') : evt.keyCode === 27;

    if (isEscape) {

      if (vm.pfwOverlayStatus) {

        vm.pfwOverlayStatus = false;
        overlayService.togglePfwOverlay();
        $scope.$apply();

      }

    }

    evt.preventDefault();

  }

  /**
   * @description : Listen for click/keyup events oustide the overlay popup.
   */
  $window.document.addEventListener('mouseup', handleClose, false);
  $window.document.addEventListener('keyup', handleEsc, false);

  vm.configService = configService;
  vm.showError = false;
  vm.errorMessages = [];
  vm.overlayGetter = overlayService.getOverlayState;
  vm.pfwOverlayStatus = overlayService.getPfwOverlayState();
  vm.overlayClick = overlayClick;
  vm.submit = submit;
  vm.clearPlaceHolder = clearPlaceHolder;
  vm.resetPlaceHolder = resetPlaceHolder;
  checkURLRequest();
  vm.setTrackingCodeSearch = setTrackingCodeSearch;
  vm.isLoggedIn = parcelsService.isValidCookie();
  vm.recaptchaSize = configService.google_recaptcha.widget_size;
  vm.recaptchaId = configService.google_recaptcha.container;
  vm.searchPage = searchPage;

  // Send Tealium tags only when needed.
  if (!errTags && (!applicationModel.urlSearch || applicationModel.urlSearch !== true)) {

    const tags = searchPage(vm.isLoggedIn);
    tealiumService.sendTags(tags);

  }

  // Check and call initialise recaptcha on the tracking-code view.
  function googleRecaptchaInitialise() {

    if (configService.google_recaptcha.enabled && $window.grecaptcha) {

      googleRecaptchaService
        .initialiseCaptcha(configService.google_recaptcha.container, configService.google_recaptcha.site_key);

    }

  }

  // Use timeout 0 here to wait until the DOM is fully loaded.
  $timeout(() => {

    if ($window.grecaptcha) {

      googleRecaptchaInitialise();

    } else {

      // Make triggeredByGoogleRecaptcha available in the window object to share with Drupal.
      $window.triggeredByGoogleRecaptcha = googleRecaptchaInitialise;

    }

  });

}

export default trackingCodeController;



// WEBPACK FOOTER //
// ./src/components/trackingcode/tracking-code.controller.js